/* istanbul ignore file */
import rules from '../../config/rbac-rules';
import { PermissionRules, Role, Permission } from '../../types/Auth';

const check = (_rules: PermissionRules, role: Role, action: Permission): boolean => {
    const permissions = _rules[role];
    if (!permissions) {
        // role is not present in the rules
        return false;
    }

    const staticPermissions = permissions.static;

    if (staticPermissions && staticPermissions.includes(action)) {
        return true;
    }

    return false;
};

const Can = (props: any): any => (check(rules, props.role, props.perform) ? props.yes() : props.no());

export default Can;
